<template>
    <form class="form-hot-tours">
        <div class="modal-header d-flex justify-content-between align-items-center">
            <img class="logo" src="/storage/images/logo.svg" alt="Anex Tour">
            <p class="header-select">
                Мгновенный подбор тура с вылетом<br>
                из <select v-model="formData.city">
                    <option v-for="(city, key) in cities"
                            :value="key"
                            :selected="key == formData.city">
                            {{ city }}
                    </option>

                <option value="Красноярска">Красноярск</option>
                <option value="Москвы">Москва</option>
                <option value="Санкт-Петербурга">Санкт-Петербург</option>
                <option value="Абакана">Абакан</option>
                <option value="Актау">Актау</option>
                <option value="Актобе">Актобе</option>
                <option value="Алматы">Алматы</option>
                <option value="Алушты">Алушта</option>
                <option value="Анадыря">Анадырь</option>
                <option value="Анапы">Анапа</option>
                <option value="Архангельска">Архангельск</option>
                <option value="Астаны">Астана</option>
                <option value="Астрахани">Астрахань</option>
                <option value="Атырау">Атырау</option>
                <option value="Барнаула">Барнаул</option>
                <option value="Белгорода">Белгород</option>
                <option value="Бишкека">Бишкек</option>
                <option value="Благовещенска">Благовещенск</option>
                <option value="Братска">Братск</option>
                <option value="Бреста">Брест</option>
                <option value="Брянска">Брянск</option>
                <option value="Вильнюса">Вильнюс</option>
                <option value="Витебска">Витебск</option>
                <option value="Владивостока">Владивосток</option>
                <option value="Владикавказа">Владикавказ</option>
                <option value="Волгограда">Волгоград</option>
                <option value="Воронежа">Воронеж</option>
                <option value="Гомеля">Гомель</option>
                <option value="Гродно">Гродно</option>
                <option value="Днепропетровска">Днепропетровск</option>
                <option value="Донецка">Донецк</option>
                <option value="Екатеринбурга">Екатеринбург</option>
                <option value="Запорожья">Запорожье</option>
                <option value="Ивано-Франковска">Ивано-Франковск</option>
                <option value="Иркутска">Иркутск</option>
                <option value="Казани">Казань</option>
                <option value="Калининграда">Калининград</option>
                <option value="Караганды">Караганда</option>
                <option value="Кемерово">Кемерово</option>
                <option value="Киева">Киев</option>
                <option value="Кишинева">Кишинев</option>
                <option value="Костаная">Костанай</option>
                <option value="Краснодара">Краснодар</option>
                <option value="Кургана">Курган</option>
                <option value="Курска">Курск</option>
                <option value="Липецка">Липецк</option>
                <option value="Луганска">Луганск</option>
                <option value="Львова">Львов</option>
                <option value="Магадана">Магадан</option>
                <option value="Магнитогорска">Магнитогорск</option>
                <option value="Махачкалы">Махачкала</option>
                <option value="Минеральных Вод">Минеральные Воды</option>
                <option value="Минска">Минск</option>
                <option value="Могилева">Могилев</option>
                <option value="Мурманска">Мурманск</option>
                <option value="Нальчика">Нальчик</option>
                <option value="Нижневартовска">Нижневартовск</option>
                <option value="Нижнекамска">Нижнекамск</option>
                <option value="Нижнего Новгорода">Нижний Новгород</option>
                <option value="Новокузнецка">Новокузнецк</option>
                <option value="Новороссийска">Новороссийск</option>
                <option value="Новосибирска">Новосибирск</option>
                <option value="Нового Уренгоя">Новый Уренгой</option>
                <option value="Одессы">Одесса</option>
                <option value="Омска">Омск</option>
                <option value="Оренбурга">Оренбург</option>
                <option value="Орска">Орск</option>
                <option value="Павлодара">Павлодар</option>
                <option value="Пензы">Пенза</option>
                <option value="Перми">Пермь</option>
                <option value="Петропавловска-Камчатского">Петропавловск-Камчатский</option>
                <option value="Риги">Рига</option>
                <option value="Ростова-на-Дону">Ростов-на-Дону</option>
                <option value="Самары">Самара</option>
                <option value="Саратова">Саратов</option>
                <option value="Симферополя">Симферополь</option>
                <option value="Сочи">Сочи</option>
                <option value="Ставрополя">Ставрополь</option>
                <option value="Сургута">Сургут</option>
                <option value="Сызрани">Сызрань</option>
                <option value="Сыктывкара">Сыктывкар</option>
                <option value="Тбилиси">Тбилиси</option>
                <option value="Тольятти">Тольятти</option>
                <option value="Томска">Томск</option>
                <option value="Трускавца">Трускавец</option>
                <option value="Тюмени">Тюмень</option>
                <option value="Улан-Удэ">Улан-Удэ</option>
                <option value="Ульяновска">Ульяновск</option>
                <option value="Уральска">Уральск</option>
                <option value="Усть-Каменогорска">Усть-Каменогорск</option>
                <option value="Уфы">Уфа</option>
                <option value="Хабаровска">Хабаровск</option>
                <option value="Ханты-Мансийска">Ханты-Мансийск</option>
                <option value="Харькова">Харьков</option>
                <option value="Хельсинки">Хельсинки</option>
                <option value="Чебоксар">Чебоксары</option>
                <option value="Челябинска">Челябинск</option>
                <option value="Читы">Чита</option>
                <option value="Шымкента">Шымкент</option>
                <option value="Южно-Сахалинска">Южно-Сахалинск</option>
                <option value="Якутска">Якутск</option>
                <option value="Ялты">Ялта</option>
            </select>
            </p>
            <p class="header-contact">
                <span>Телефон для частных лиц:</span><br>
                <a v-if="selectedCity == 'Красноярск'" href="tel:+73912163334">+7 (391) 216-33-34</a>
                <a v-if="selectedCity == 'Новосибирск'" href="tel:+73833829990">+7 (383) 382-9990</a>
            </p>
            <button type="button" class="close" data-dismiss="modal" aria-label="Закрыть">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="body-steps d-flex justify-content-center">
            <div
                v-for="step in steps"
                :key="step.id"
                :class="'step step-' + step.id + (activeStep >= step.id ? ' passed' : '') + (activeStep == step.id ? ' active' : '')"
                @click="stepSwitch(step.id)">
                <div class="step-icon">
                    <i></i>
                </div>
                <div class="step-text">
                    Шаг {{ step.id }}
                </div>
            </div>
        </div>
        <div class="modal-body">
            <div class="steps-content">
                <div v-show="activeStep == 1" class="step-content step-content-1">
                    <div class="step-title">
                        Где вы хотите отдохнуть?
                    </div>
                    <div class="step-subtitle">
                        Выберите страну
                    </div>
                    <div class="step-data">
                        <div class="form-field">
                            <select v-model="formData.country">
                                <option v-for="cntry in countries"
                                        :key="cntry.id"
                                        :value="cntry.id">
                                    {{cntry.name}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div v-show="activeStep == 2" class="step-content step-content-2">
                    <div class="step-title">
                        Когда Вы хотите вылететь?
                    </div>
                    <div class="step-subtitle">
                        Выберите дату
                    </div>
                    <div class="step-data">
                        <div class="form-field">
                            <input type="date" v-model="formData.dateStart" />
                        </div>
                    </div>
                </div>
                <div v-show="activeStep == 3" class="step-content step-content-3">
                    <div class="step-title">
                        На сколько ночей?
                    </div>
                    <div class="step-subtitle">
                        Укажите продолжительность поездки
                    </div>
                    <div class="step-data">
                        <div class="input-number">
                            <div class="input-control minus" @click="inputChange('duration', 'minus')">-</div>
                            <div class="input">
                                <input type="text" v-model="formData.duration" @change="inputNumberCheck('duration')" />
                                {{ durationText }}
                            </div>
                            <div class="input-control plus" @click="inputChange('duration', 'plus')">+</div>
                        </div>
                    </div>
                </div>
                <div v-show="activeStep == 4" class="step-content step-content-4">
                    <div class="step-title">
                        Кто едет?
                    </div>
                    <div class="step-subtitle">
                        Взрослых
                    </div>
                    <div class="step-data">
                        <div class="input-number">
                            <div class="input-control minus" @click="inputChange('adult', 'minus')">-</div>
                            <div class="input">
                                <input type="text" v-model="formData.adult" @change="inputNumberCheck('adult')" />
                                {{ adultText }}
                            </div>
                            <div class="input-control plus" @click="inputChange('adult', 'plus')">+</div>
                        </div>
                    </div>
                    <div class="step-subtitle">
                        Детей
                    </div>
                    <div class="step-data">
                        <div class="input-number">
                            <div class="input-control minus" @click="inputChange('children', 'minus')">-</div>
                            <div class="input">
                                <input type="text" v-model="formData.children" @change="inputNumberCheck('children')" />
                                {{ childrenText }}
                            </div>
                            <div class="input-control plus" @click="inputChange('children', 'plus')">+</div>
                        </div>
                    </div>
                </div>
                <div v-show="activeStep == 5" class="step-content step-content-5">
                    <div class="step-title">
                        Ваши контактные данные
                    </div>
                    <div class="step-data">
                        <div class="form-field">
                            <input required type="text" v-model="formData.name" placeholder="Имя *" :class="(errors.name ? 'error' : '')" @input="errors.name = false" />
                        </div>
                        <div class="form-field">
                            <input type="tel"
                                   autocomplete="tel"
                                   v-phone
                                   v-model="formData.phone"
                                   placeholder="Телефон *"
                                   :class="(errors.phone ? 'error' : '')"
                                   @input="errors.phone = false"
                                   required />
                        </div>
                        <div class="form-field">
                            <input type="email"
                                   v-model="formData.email"
                                   :class="(errors.email ? 'error' : '')"
                                   @input="errors.email = false"
                                   placeholder="Email" />
                        </div>
                        <div class="form-field">
                            <label>
                                <input required type="checkbox" v-model="formData.agree" :class="(errors.agree ? 'error' : '')" @input="errors.agree = false" />
                                Я согласен/согласна на обработку моих персональных данных
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-buttons d-flex justify-content-between">
            <div v-show="(activeStep == 1)"></div>
            <button v-if="(activeStep > 1)" type="button" class="btn btn-back" @click="activeStep = activeStep - 1">< {{ steps[activeStep - 1].buttonTitle }}</button>
            <button v-if="(activeStep < 5)" @click="activeStep = activeStep + 1" class="btn btn-red" type="button">{{ steps[activeStep + 1].buttonTitle }} ></button>
            <button :disabled="sendButton.disabled" v-show="(activeStep == 5)" @click.stop.prevent="sendForm" :class="'btn ' + sendButton.class" type="submit">{{ sendButton.text }}</button>
        </div>
    </form>
</template>

<script>
    export default {
        name: "form-hot-tours",
        props: {
            metrikaNumber: Number,
            countries: {},
            cities: Object,
            selectedCity: String,
            selectedCountry: Number,
        },
        data() {
            return {
                steps: {
                  1: {
                      id: 1,
                      buttonTitle: 'Выбор страны',
                  },
                  2: {
                      id: 2,
                      buttonTitle: 'Выбор даты',
                  },
                  3: {
                      id: 3,
                      buttonTitle: 'Длительность',
                  },
                  4: {
                      id: 4,
                      buttonTitle: 'Кто едет',
                  },
                  5: {
                      id: 5,
                      buttonTitle: 'Контакты',
                  },
                },
                activeStep: 1,
                formData: {
                    city: '',
                    country: '',
                    dateStart: '',
                    duration: 1,
                    adult: 2,
                    children: 1,
                    name: '',
                    phone: '',
                    email: '',
                    agree: false,
                    url: '',
                },
                sendButton: {
                    text: 'Отправить запрос',
                    class: 'btn-red',
                    disabled: false,
                },
                errors: {},
            }
        },
        mounted() {
            let date = new Date();

            date.setDate(date.getDate() + 1);
            this.formData.dateStart = this.dateFormat(date);

            if (this.selectedCity) {
                this.formData.city = this.selectedCity;
            } else {
                var keys = Object.keys(this.cities);
                this.formData.city = keys[0];
            }
            this.formData.country = this.selectedCountry;

        },
        computed: {
            durationText() {
                switch (+this.formData.duration) {
                    case 1:
                    case 21:
                    case 31:
                        return 'ночь';
                    case 2:
                    case 22:
                    case 32:
                    case 3:
                    case 23:
                    case 33:
                    case 4:
                    case 24:
                    case 34:
                        return 'ночи';
                    default:
                        return 'ночей';
                }
            },
            adultText() {
                switch (+this.formData.adult) {
                    case 1:
                        return 'взрослый';
                    default:
                        return 'взрослых';
                }
            },
            childrenText() {
                switch (+this.formData.children) {
                    case 1:
                        return 'ребенок';
                    case 2:
                    case 3:
                    case 4:
                        return 'ребенка';
                    default:
                        return 'детей';
                }
            },
        },
        methods: {
            stepSwitch(step) {
                this.activeStep = step;
            },
            dateFormat(date) {
                let day = date.getDate();
                day = day < 10 ? '0' + day : day;
                let month = date.getMonth() + 1;
                month = month < 10 ? '0' + month : month;

                return date.getFullYear() + '-' + month + '-' + day;
            },
            inputChange(field, operator) {
                let min = 1;
                if (field == 'children') {
                    min = 0;
                }
                if (operator == 'plus') {
                    this.formData[field] = +this.formData[field] + 1;
                } else {
                    if (this.formData[field] > min) {
                        this.formData[field] = this.formData[field] - 1;
                    }
                }
            },
            inputNumberCheck(field) {
                let min = 1;
                if (field == 'children') {
                    min = 0;
                }
                if (+this.formData[field] < min || !Number.isInteger(+this.formData[field]) ) {
                    this.formData[field] = min;
                }
            },
            sendForm() {
                this.errors = {};
                if (this.validate()) {
                    this.formData.url = window.location.href;
                    this.sendButton.text = 'Отправка формы...';
                    this.sendButton.class = 'btn-red sending';
                    this.sendButton.disabled = true;
                    let ref = this;
                    this.axios.post('/sendmail/form-hot-tours', this.formData)
                        .then(function (response) {
                            ref.sendButton.text = 'Заявка отправлена';
                            ref.sendButton.class = 'btn-green sended';

                            if (ym) {
                                ym(ref.metrikaNumber, 'reachGoal', 'form_hot_tour');
                            }

                            setTimeout( function () {
                                jQuery("#hotToursModal").modal('hide');
                            }, 2000);

                            $.ajax({
                                type: "GET",
                                cache: false,
                                url: '/api/get-utm-cookies',
                                dataType: 'json',
                                success: function (cookies) {
                                    if (cookies) {
                                        response.data['utm_source'] = cookies.utm_source || '';
                                        response.data['utm_medium'] = cookies.utm_medium || '';
                                        response.data['utm_campaign'] = cookies.utm_campaign || '';
                                        response.data['utm_term'] = cookies.utm_term || '';
                                        response.data['utm_content'] = cookies.utm_content || '';
                                    }

                                    const getClientID = function () {
                                        return new Promise((resolve, reject) => {
                                            if (typeof ym !== 'undefined' && typeof Ya !== 'undefined' && Ya._metrika) {
                                                try {
                                                    const counterId = Ya._metrika.getCounters()[0].id;
                                                    ym(counterId, 'getClientID', function(clientID) {
                                                        resolve(clientID);
                                                    });
                                                } catch (e) {
                                                    resolve(null);
                                                }
                                            } else {
                                                resolve(null);
                                            }
                                        });
                                    };

                                    getClientID().then(clientID => {
                                        if (clientID) {
                                            response.data['yclid'] = clientID;
                                        }

                                        console.log(cookies, response.data);

                                        $.ajax({
                                            type: "POST",
                                            cache: false,
                                            url: 'https://tglk.ru/in/B4PobPHkmksQvmOl',
                                            data: response.data,
                                            success: function (data) {
                                                // console.log(data);
                                            },
                                            error: function () {
                                                console.log(data);
                                            }
                                        });
                                    });
                                },
                                error: function () {
                                    console.log(data);
                                }
                            });
                        })
                        .catch(function (error) {
                            console.log(error);
                            ref.sendButton.text = 'Ошибка';
                            ref.sendButton.class = 'error';
                        });

                } else {
                    // console.log(this.errors);
                }
            },
            validate() {
                if (!this.formData.country) {
                    this.errors.country = true;
                }
                if (!this.formData.dateStart) {
                    this.errors.dateStart = true;
                }
                if (!this.formData.name) {
                    this.errors.name = true;
                }
                if (!this.formData.phone || !this.formData.phone.replace(/\D/g, '').match(/\d{11}/)) {
                    this.errors.phone = true;
                }
                if (!this.formData.agree) {
                    this.errors.agree = true;
                }
                const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (this.formData.email && !emailRegex.test(String(this.formData.email).toLowerCase())) {
                    this.errors.email = true;
                }

                if (Object.keys(this.errors).length == 0) {
                    return true;
                } else {
                    return false;
                }
            }
        },
    }
</script>
